<footer class="site-footer">
  <div class="container">
    <p>© 2026 {{ fullName }}. Tous droits réservés.</p>
    <p>Portfolio conçu avec Angular 21.</p>
  </div>
</footer>
